<div class="delete-citations-dialog">
  <span class="close-btn-container">
    <button
      mat-icon-button
      class="mat-icon-button close-icon"
      (click)="closeCleanUpCommentsDialog()"
    >
      <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color"
        >close</mat-icon
      >
    </button>
  </span>
  <ng-container>
    <div class="delete-references-dialog-content">
      <h1 class="heading delete-references-heading">
        {{ 'CLEAN_UP_COMMENTS.HEADING' | translate }}
      </h1>
      <ng-container>
        <div class="delete-references-title">
          <p>{{ 'CLEAN_UP_COMMENTS.MESSAGE' | translate }}</p>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <div class="delete-dialog-actions">
    <button
      type="button"
      class="wk-button wk-button-text"
      (click)="closeCleanUpCommentsDialog()"
    >
      {{ 'CLEAN_UP_COMMENTS.CANCEL' | translate }}
    </button>
    <button
      type="button"
      class="wk-button wk-button-danger"
      (click)="deleteEditorialComments()"
    >
      {{ 'CLEAN_UP_COMMENTS.DELETE' | translate }}
    </button>
  </div>
</div>
